
import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Copy, Mail } from 'lucide-react';

interface SharingToolsProps {
  handleCopyLink: () => void;
  handleShowShareDialog: () => void;
}

const SharingTools = ({ handleCopyLink, handleShowShareDialog }: SharingToolsProps) => {
  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-lg">Share Assessment</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <Button 
            variant="outline" 
            className="w-full flex items-center justify-center"
            onClick={handleCopyLink}
          >
            <Copy size={16} className="mr-2" /> Copy Link
          </Button>
          
          <Button 
            variant="purple" 
            className="w-full flex items-center justify-center"
            onClick={handleShowShareDialog}
          >
            <Mail size={16} className="mr-2" /> Share via Email
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default SharingTools;
